import request from '@/utils/request'
import https from '@/utils/https.js'
export function getJobList(job_name, job_code) {
    return https({
        url: '/api/job/getJobList',
        method: 'post',
        data: {
            job_name: job_name,
            job_code: job_code
        }
    })
}

export function getJobSurvey(job_code) {
    return https({
        url: '/api/job/getJobSurvey',
        method: 'post',
        data: {
            job_code: job_code,
        }
    })
}

export function getPositionDetail(id) {
    return https({
        url: '/api/job/getPositionDetail',
        method: 'post',
        data: {
            id: id,
        }
    })
}

export function getJobCategory() {
    return https({
        url: '/api/job/getJobCategory',
        method: 'post',
        data: {
        }
    })
}

export function getIndustrySalary() {
    return https({
        url: '/api/job/getIndustrySalary',
        method: 'post',
        data: {
        }
    })
}